<template>
  <div class="item-two">
    <div class="left-area">
      <p class="left-area-bg" style="margin-bottom: 5px">
        <span class="area-bg-left">视点聚焦</span>
        <font class="area-bg-right">更多》</font>
      </p>
      <div class="left-area-item" v-for="(item,index) in leftArr" :key="index">
        <span class="lbl-count">{{item.id}}</span>
        <div class="content-item">
          <p class="item-title">{{item.title || ''}}</p>
          <p class="item-des"><span>{{item.time}}</span><span class="des-count">阅读:{{item.readCount}}</span></p>
        </div>
      </div>
    </div>
    <div class="right-area">
      <p class="right-area-bg" style="margin-bottom: 5px">
        <span class="area-bg-right-right">今日主站品牌排行</span>
      </p>
      <div class="center-box-area">
          <div v-for="(item,index) in temData" :key="index" class="center-item">
            <span class="center-title">{{item.name || ''}}</span>
            <p><countTo :startVal='0' :endVal='item.count' :duration='10000'></countTo></p>
          </div>
      </div>
      <div class="center-bottom-area">
        <div v-for="(item,index) in listData" :key="index">
          <span class="lbl-count">{{+index + 1}}</span>
          <div class="content-item">
            <p class="item-des"><span>{{item.name}}</span>
              <span class="des-count"><countTo :startVal='0' :endVal='item.count' :duration='10000'></countTo>
              </span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  name: "right-module-two",
  components:{
    countTo
  },
  data(){
    return {
      leftArr: [{
        id: '1',
        title: '再生：此一年，彼一年（从...',
        time: '2022-06-10 01:26',
        readCount: '2565'
      },{
        id: '2',
        title: '再生：此一年，彼一年（从...',
        time: '2022-06-10 01:26',
        readCount: '2565'
      },{
        id: '3',
        title: '再生：此一年，彼一年（从...',
        time: '2022-06-10 01:26',
        readCount: '2565'
      },{
        id: '4',
        title: '再生：此一年，彼一年（从...',
        time: '2022-06-10 01:26',
        readCount: '2565'
      },{
        id: '5',
        title: '再生：此一年，彼一年（从...',
        time: '2022-06-10 01:26',
        readCount: '2565'
      }],
      temData: [{
        count: 1256,
        name: '品牌1'
      },{
        count: 1256,
        name: '品牌2'
      },{
        count: 1256,
        name: '品牌3'
      }],
      listData: [{
        count: 1256,
        name: '品牌3'
      },{
        count: 1256,
        name: '品牌3'
      },{
        count: 1256,
        name: '品牌3'
      },{
        count: 1256,
        name: '品牌3'
      },{
        count: 1256,
        name: '品牌3'
      }]
    }
  }
}
</script>
<style scoped>
.item-two {
  display: flex;
  align-items: center;
  padding: 20px;
  height: calc(100% - 20px);
}
.left-area,.right-area {
  flex: 1;
  color: #fff;
}
.right-area{
  margin-left: 5px;
}
.left-area {
  margin-right: 5px;
}
.item-two {
  display: flex;
}
.content-item {
  display: inline-block;
  font-size: 11px;
  width: calc(100% - 40px);
  margin: 3px 0 5px;
}
.lbl-count {
  vertical-align: top;
  background: #01266C;
  color: #666;
  padding: 2px;
  display: inline-block;
  font-size: 12px;
  margin-top: 5px;
}
.left-area-bg,.right-area-bg {
  color: #02266C;
  font-size: 13px;
  display: flex;
  height: 26px;
  align-items: center;
}
.left-area-bg{
  background: url("../../../assets/bj-3.fw.png");
  background-size: 100% 100%;
}
.right-area-bg {
  background: url("../../../assets/bj-4.fw.png");
  background-size: 100% 100%;
}

.area-bg-left,.area-bg-right-right {
  font-weight: bold;
  flex: 1;
  margin-left: 10px;
  text-align: left;
}
.area-bg-right {
  color: #fff;
  opacity: 0.7;
  text-align: right;
}
.item-title {
  font-size: 12px;
  font-family: ”黑体“;
}
.item-des {
  color: #FFFFFF;
  opacity: 0.6;
  display: flex;
  font-size: 11px;
  align-items: center;
}
.des-count {
  flex: 1;
  text-align: right;
}
.center-box-area {
  display: flex;
  margin: 18px 0 10px;
  align-items: center;
}
.center-item {
  flex: 1;
  padding: 5px 10px;
  color: #fff;
  background: -webkit-linear-gradient(90deg, #769AFF, #154EF7);
  margin: 5px 3px;
  text-align: center;
}
.center-title {
  font-size: 13px;
}
.center-bottom-area .item-des {
  font-size: 12px;
  color: #fff;
  opacity: 1;
}
.center-bottom-area .lbl-count {
  background: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/right-module-two.vue